export default "__VITE_ASSET__BmLVTi_s__"